module.exports = __webpack_public_path__ + "img/黑种草子.970916a2.jpg";